import { Component, inject } from '@angular/core';
import { AuthService } from '@bn/auth/services';

@Component({
  template: '',
  standalone: false,
})
export class LogoutPage {
  private readonly authService = inject(AuthService);

  constructor() {
    this.logout();
  }

  private logout(): void {
    this.authService.logout();
  }
}
